import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [resetLink, setResetLink] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");
    setResetLink("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message || "If that email exists, a reset link was sent.");
      if (data.reset_link) setResetLink(data.reset_link);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md fade-in">
        <div className="card-soft p-8">
          <h1 className="font-heading text-2xl font-medium text-[#2C302E]">Reset your password</h1>
          <p className="text-sm text-[#59605C] mt-1">
            Enter your email and we’ll send you a reset link.
          </p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-soft"
              data-testid="forgot-email-input"
              placeholder="you@example.com"
            />
            {error && (
              <div className="rounded-xl bg-[#FDF2F0] border border-[#F5D8D4] text-[#8C3A30] text-sm p-3" data-testid="forgot-error">
                {error}
              </div>
            )}
            {message && (
              <div className="rounded-xl bg-[#EEF3EC] border border-[#D5E1D3] text-[#3B5B3E] text-sm p-3" data-testid="forgot-success">
                {message}
                {resetLink && (
                  <div className="mt-2 text-xs">
                    Dev mode — <a href={resetLink} className="underline break-all" data-testid="forgot-reset-link">{resetLink}</a>
                  </div>
                )}
              </div>
            )}
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="forgot-submit-button">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
          <div className="mt-6 text-sm text-center text-[#59605C]">
            <Link to="/login" data-testid="forgot-to-login" className="text-[#4A6148] font-medium hover:underline">Back to login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
